import { useEffect, useState } from "react";
import { useTheme } from "../ThemeProvider";

const MOTIVOS_RAPIDOS = [
  "Venta/alquiler u operación cerrada",
  "Reserva firmada",
  "El propietario retira la propiedad",
  "Precio o condiciones",
  "Error de alta o duplicado",
  "Decisión interna",
];

const TITULOS = {
  vendida: "Marcar como vendida/alquilada",
  reservada: "Marcar como reservada",
  ocultar: "Ocultar propiedad",
  eliminar: "Archivar propiedad",
};

export default function ModalMotivoBajaPropiedad({ isOpen, accionId, count, onConfirm, onClose }) {
  const { theme } = useTheme();
  const c = theme.colors;
  const isDark = theme.name === "dark";
  const [preset, setPreset] = useState("");
  const [textoLibre, setTextoLibre] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!isOpen) return;
    setPreset("");
    setTextoLibre("");
    setError("");
  }, [isOpen, accionId]);

  if (!isOpen || !accionId) return null;

  const motivoFinal = () => {
    const libre = String(textoLibre || "").trim();
    const pre = String(preset || "").trim();
    if (libre && pre) return `${pre}. ${libre}`;
    return libre || pre;
  };

  const confirmar = () => {
    const motivo = motivoFinal();
    if (!motivo) {
      setError("Indica el motivo: elige un botón rápido o escribe el motivo.");
      return;
    }
    onConfirm(motivo);
  };

  const titulo = TITULOS[accionId] || "Motivo de baja";
  const n = count || 1;

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 1100,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: c.bgPanel,
          borderRadius: 14,
          padding: 22,
          width: "100%",
          maxWidth: 480,
          border: `1px solid ${c.border}`,
          boxShadow: isDark ? "0 16px 48px rgba(0,0,0,0.5)" : "0 16px 48px rgba(0,0,0,0.12)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
          <div>
            <div style={{ fontSize: 16, fontWeight: 700, color: c.textPrimary }}>{titulo}</div>
            <div style={{ fontSize: 12, color: c.textMuted, marginTop: 4 }}>
              {n === 1 ? "1 propiedad seleccionada" : `${n} propiedades seleccionadas`}
            </div>
          </div>
          <button
            type="button"
            onClick={onClose}
            style={{ background: "none", border: "none", color: c.textMuted, fontSize: 22, cursor: "pointer", lineHeight: 1 }}
          >
            ×
          </button>
        </div>

        <p style={{ fontSize: 13, color: c.textSecondary, margin: "12px 0 14px", lineHeight: 1.45 }}>
          El motivo queda registrado en la ficha. Puedes combinar un motivo rápido con texto libre.
        </p>

        <div style={{ fontSize: 11, fontWeight: 600, color: c.textMuted, marginBottom: 8, textTransform: "uppercase" }}>
          Motivos rápidos
        </div>
        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 14 }}>
          {MOTIVOS_RAPIDOS.map((m) => {
            const activo = preset === m;
            return (
              <button
                key={m}
                type="button"
                onClick={() => {
                  setPreset(activo ? "" : m);
                  setError("");
                }}
                style={{
                  padding: "6px 10px",
                  fontSize: 12,
                  fontWeight: 500,
                  borderRadius: 8,
                  border: `1px solid ${activo ? c.accentBlue : c.border}`,
                  background: activo ? (isDark ? "rgba(59,130,246,0.25)" : c.accentBlueLight) : c.bgInput,
                  color: activo ? c.accentBlue : c.textSecondary,
                  cursor: "pointer",
                }}
              >
                {m}
              </button>
            );
          })}
        </div>

        <label style={{ fontSize: 11, fontWeight: 600, color: c.textMuted, display: "block", marginBottom: 6 }}>
          Motivo (texto libre)
        </label>
        <textarea
          value={textoLibre}
          onChange={(e) => {
            setTextoLibre(e.target.value);
            setError("");
          }}
          rows={3}
          placeholder="Detalle adicional del motivo…"
          style={{
            width: "100%",
            boxSizing: "border-box",
            padding: "10px 12px",
            borderRadius: 8,
            border: `1px solid ${error ? c.accentRed : c.border}`,
            background: c.bgInput,
            color: c.textPrimary,
            fontSize: 13,
            resize: "vertical",
            fontFamily: "inherit",
            lineHeight: 1.45,
          }}
        />
        {error && (
          <p style={{ fontSize: 12, color: c.accentRed, marginTop: 8, marginBottom: 0 }}>{error}</p>
        )}

        <div style={{ display: "flex", gap: 8, marginTop: 16, justifyContent: "flex-end" }}>
          <button
            type="button"
            onClick={onClose}
            style={{
              padding: "9px 16px",
              borderRadius: 8,
              border: `1px solid ${c.border}`,
              background: "transparent",
              color: c.textSecondary,
              fontSize: 13,
              cursor: "pointer",
            }}
          >
            Cancelar
          </button>
          <button
            type="button"
            onClick={confirmar}
            style={{
              padding: "9px 18px",
              borderRadius: 8,
              border: "none",
              background: c.accentBlue || "#2563eb",
              color: "#fff",
              fontSize: 13,
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
}
